/*

 MIT License

 Copyright (c) 2022 Looker Data Sciences, Inc.

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.

 */

export const iconsList = [
  'AnalyticsApp',
  'Beaker',
  'BrowseTable',
  'CalendarDay',
  'CalendarHour',
  'CalendarMonth',
  'CalendarQuarter',
  'CalendarWeek',
  'ChartArea',
  'ChartBar',
  'ChartBoxPlot',
  'ChartTimeline',
  'CheckProgress',
  'CollapseAll',
  'ColorFill',
  'ColorText',
  'CrossFilter',
  'DashboardFile',
  'DashboardGauge',
  'DigitalMarketingApp',
  'DimensionFill',
  'DocumentFile',
  'Download',
  'ExpandCollapse',
  'Explore',
  'FieldString',
  'FieldTier',
  'FindSelected',
  'Flag',
  'GitBranch',
  'IdeDimension',
  'IdeDimensionGroup',
  'IdeFileDashboard',
  'IdeFileDocument',
  'IdeFileGeneric',
  'IdeFileLookML',
  'IdeFileManifest',
  'IdeFileModel',
  'IdeParameter',
  'LQA',
  'LogoRings',
  'LookerLogo',
  'Marketplace',
  'ModelFile',
  'More',
  'Notes',
  'Pivot',
  'Public',
  'QuickStart',
  'Reports',
  'Return',
  'SalesAnalytics',
  'SendWebhook',
  'SqlRunner',
  'UserAttributes',
  'ViewFile',
  'VisArea',
  'VisBar',
  'VisColumn',
  'VisLine',
  'VisMap',
  'VisPie',
  'VisScatter',
  'VisSingleValue',
  'VisTable',
]

export { AnalyticsApp } from './AnalyticsApp'
export { Beaker } from './Beaker'
export { BrowseTable } from './BrowseTable'
export { CalendarDay } from './CalendarDay'
export { CalendarHour } from './CalendarHour'
export { CalendarMonth } from './CalendarMonth'
export { CalendarQuarter } from './CalendarQuarter'
export { CalendarWeek } from './CalendarWeek'
export { ChartArea } from './ChartArea'
export { ChartBar } from './ChartBar'
export { ChartBoxPlot } from './ChartBoxPlot'
export { ChartTimeline } from './ChartTimeline'
export { CheckProgress } from './CheckProgress'
export { CollapseAll } from './CollapseAll'
export { ColorFill } from './ColorFill'
export { ColorText } from './ColorText'
export { CrossFilter } from './CrossFilter'
export { DashboardFile } from './DashboardFile'
export { DashboardGauge } from './DashboardGauge'
export { DigitalMarketingApp } from './DigitalMarketingApp'
export { DimensionFill } from './DimensionFill'
export { DocumentFile } from './DocumentFile'
export { Download } from './Download'
export { ExpandCollapse } from './ExpandCollapse'
export { Explore } from './Explore'
export { FieldString } from './FieldString'
export { FieldTier } from './FieldTier'
export { FindSelected } from './FindSelected'
export { Flag } from './Flag'
export { GitBranch } from './GitBranch'
export { IdeDimension } from './IdeDimension'
export { IdeDimensionGroup } from './IdeDimensionGroup'
export { IdeFileDashboard } from './IdeFileDashboard'
export { IdeFileDocument } from './IdeFileDocument'
export { IdeFileGeneric } from './IdeFileGeneric'
export { IdeFileLookML } from './IdeFileLookML'
export { IdeFileManifest } from './IdeFileManifest'
export { IdeFileModel } from './IdeFileModel'
export { IdeParameter } from './IdeParameter'
export { LQA } from './LQA'
export { LogoRings } from './LogoRings'
export { LookerLogo } from './LookerLogo'
export { Marketplace } from './Marketplace'
export { ModelFile } from './ModelFile'
export { More } from './More'
export { Notes } from './Notes'
export { Pivot } from './Pivot'
export { Public } from './Public'
export { QuickStart } from './QuickStart'
export { Reports } from './Reports'
export { Return } from './Return'
export { SalesAnalytics } from './SalesAnalytics'
export { SendWebhook } from './SendWebhook'
export { SqlRunner } from './SqlRunner'
export { UserAttributes } from './UserAttributes'
export { ViewFile } from './ViewFile'
export { VisArea } from './VisArea'
export { VisBar } from './VisBar'
export { VisColumn } from './VisColumn'
export { VisLine } from './VisLine'
export { VisMap } from './VisMap'
export { VisPie } from './VisPie'
export { VisScatter } from './VisScatter'
export { VisSingleValue } from './VisSingleValue'
export { VisTable } from './VisTable'
